import React from 'react';
// import styled from 'styled-components';
import ErrorFallback from './ErrorFallback';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      // console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          resetError={() =>
            this.setState({ hasError: false, error: null, errorInfo: null })
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

// Unused styled components - keeping for potential future use
// const ErrorContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 100vh;
//   background-color: #000;
//   color: white;
//   padding: 20px;
// `;

// const ErrorContent = styled.div`
//   text-align: center;
//   max-width: 600px;
//   padding: 40px;
//   border-radius: 12px;
//   background-color: rgba(76, 0, 101, 0.1);
//   border: 2px solid #4c0065;
// `;

// const ErrorIcon = styled.div`
//   font-size: 4rem;
//   margin-bottom: 20px;
// `;

// const ErrorTitle = styled.h1`
//   font-size: 2rem;
//   margin-bottom: 20px;
//   color: #4c0065;
// `;

// const ErrorMessage = styled.p`
//   font-size: 1.2rem;
//   margin-bottom: 30px;
//   line-height: 1.6;
// `;

// const ErrorActions = styled.div`
//   display: flex;
//   gap: 20px;
//   justify-content: center;
//   flex-wrap: wrap;
// `;

// const RetryButton = styled.button`
//   padding: 15px 30px;
//   background-color: #4c0065;
//   color: white;
//   border: none;
//   border-radius: 8px;
//   font-size: 1.1rem;
//   cursor: pointer;
//   transition: background-color 0.3s ease;

//   &:hover {
//     background-color: #6a0080;
//   }
// `;

// const HomeButton = styled.button`
//   padding: 15px 30px;
//   background-color: transparent;
//   color: #4c0065;
//   border: 2px solid #4c0065;
//   border-radius: 8px;
//   font-size: 1.1rem;
//   cursor: pointer;
//   transition: all 0.3s ease;

//   &:hover {
//     background-color: #4c0065;
//     color: white;
//   }
// `;

// const ErrorDetails = styled.div`
//   margin-top: 30px;
//   text-align: left;

//   details {
//     cursor: pointer;
//   }

//   summary {
//     margin-bottom: 10px;
//     font-weight: bold;
//   }

//   pre {
//     background-color: rgba(0, 0, 0, 0.3);
//     padding: 15px;
//     border-radius: 8px;
//     overflow-x: auto;
//     font-size: 0.9rem;
//     white-space: pre-wrap;
//   }
// `;
